import React from 'react';
import Typography from '@material-ui/core/Typography';

import Img from 'retired/Img';

interface StatusProps {
  title: string;
  icon: SVGElement;
  color: string;
  textColor: string;
  style?: React.CSSProperties;
}

const Status = ({ title, icon, color, textColor, style }: StatusProps): React.ReactElement => (
  <div
    style={{
      borderRadius: 20,
      padding: '5px 10px',
      backgroundColor: color,
      ...style,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography component="p" style={{ fontSize: 12, color: textColor }}>
        {title}
      </Typography>
      <Img src={icon} alt={title} style={{ marginLeft: 12, width: 12, height: 12 }} />
    </div>
  </div>
);

export default Status;
